import { render } from "./Claim_1_Bill_submit.vue?vue&type=template&id=142f7f6a&ts=true"
import script from "./Claim_1_Bill_submit.vue?vue&type=script&lang=ts"
export * from "./Claim_1_Bill_submit.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__